import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  AppBar,
  Badge,
  IconButton,
  Toolbar,
  useMediaQuery,
} from '@mui/material';
import {
  NotificationsOutlined as NotificationsIcon,
  Menu as MenuIcon,
} from '@mui/icons-material';

import { NotificationsPopover } from 'components';
//import { sseFetchData } from 'utils/callApi';
import { callApi } from 'utils';

const TopBar = ({hideNavBar, onOpenNavBarDrawer, styles}) => {
  const notificationsRef = useRef(null);
  const [notifications, setNotifications] = useState([]);
  const [notificationsOpen, setNotificationsOpen] = useState(false);
  const lgUp = useMediaQuery(theme => theme.breakpoints.up('lg'));

  useEffect(() => {
    //sseFetchData('/notifications', (msgs) => {
    //  setNotifications(prev => [...prev, ...msgs].slice(-30));
    //});
    let from = localStorage.getItem('notification') || '';
    const itvl = setInterval(() => {
      callApi(`/notifications?from=${encodeURIComponent(from)}`)
        .then(msgs => {
          if (msgs?.length) {
            setNotifications(prev => msgs.length >= 8 ? msgs : [...msgs, ...prev].slice(0, 8));
            from = msgs[0].created_at;
            localStorage.setItem("notification", from);
          }
        })
        .catch(console.log);
    }, 300_000);

    return () => clearInterval(itvl);
  }, []);

  const handleNotificationsOpen = () => setNotificationsOpen(true);
  const handleNotificationsClose = () => {
    setNotificationsOpen(false);
    setNotifications(prev => prev.map(n => ({...n, read: true})));
  }

  const unreadNotifications = notifications.filter(n => !n.read).length;
  const navBarHidden = ({always: true, never: false, auto: !lgUp})[hideNavBar];

  return (
    <AppBar
      sx={{
        boxShadow: 'none',
        ...styles
      }}
      color="primary"
    >
      <Toolbar variant="dense">
      {navBarHidden && (
        <IconButton
          color="inherit"
          onClick={onOpenNavBarDrawer}
        >
          <MenuIcon />
        </IconButton>
      )}
        <Box sx={{flexGrow: 1}} />
        <IconButton
          sx={{marginLeft: 1}}
          color="inherit"
          onClick={handleNotificationsOpen}
          ref={notificationsRef}
        >
          <Badge badgeContent={unreadNotifications} color="secondary">
            <NotificationsIcon />
          </Badge>
        </IconButton>
      </Toolbar>
      <NotificationsPopover
        anchorEl={notificationsRef.current}
        notifications={notifications}
        onClose={handleNotificationsClose}
        open={notificationsOpen}
      />
    </AppBar>
  );
};

TopBar.propTypes = {
  hideNavBar: PropTypes.oneOf(['always', 'never', 'auto']),
  onOpenNavBarDrawer: PropTypes.func,
  styles: PropTypes.object,
};

export default TopBar;
